/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { TipoPraticaCanaleComunicazioneDTO } from '../model/tipo-pratica-canale-comunicazione-dto';
// @ts-ignore
import { TipoPraticaCanaleComunicazionePatchForm } from '../model/tipo-pratica-canale-comunicazione-patch-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TipoPraticaCanaleComunicazioneControllerServiceInterface,
    ListTipoPraticaCanaliComunicazioneRequestParams,
    PatchTipoPraticaCanaleComunicazioneRequestParams
} from './tipo-pratica-canale-comunicazione-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class TipoPraticaCanaleComunicazioneControllerService extends BaseService implements TipoPraticaCanaleComunicazioneControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Lista dei 3 canali di un evento (EMAIL/SMS/WA)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/eventi-comunicazione/{idEvento}/canali
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listTipoPraticaCanaliComunicazione(requestParameters: ListTipoPraticaCanaliComunicazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<TipoPraticaCanaleComunicazioneDTO>>;
    public listTipoPraticaCanaliComunicazione(requestParameters: ListTipoPraticaCanaliComunicazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<TipoPraticaCanaleComunicazioneDTO>>>;
    public listTipoPraticaCanaliComunicazione(requestParameters: ListTipoPraticaCanaliComunicazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<TipoPraticaCanaleComunicazioneDTO>>>;
    public listTipoPraticaCanaliComunicazione(requestParameters: ListTipoPraticaCanaliComunicazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listTipoPraticaCanaliComunicazione.');
        }
        const idEvento = requestParameters?.idEvento;
        if (idEvento === null || idEvento === undefined) {
            throw new Error('Required parameter idEvento was null or undefined when calling listTipoPraticaCanaliComunicazione.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/eventi-comunicazione/${this.configuration.encodeParam({name: "idEvento", value: idEvento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/canali`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<TipoPraticaCanaleComunicazioneDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch del canale: toggle abilitato e/o edit testo (richiede version)
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/eventi-comunicazione/{idEvento}/canali/{idCanale}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public patchTipoPraticaCanaleComunicazione(requestParameters: PatchTipoPraticaCanaleComunicazioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TipoPraticaCanaleComunicazioneDTO>;
    public patchTipoPraticaCanaleComunicazione(requestParameters: PatchTipoPraticaCanaleComunicazioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TipoPraticaCanaleComunicazioneDTO>>;
    public patchTipoPraticaCanaleComunicazione(requestParameters: PatchTipoPraticaCanaleComunicazioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TipoPraticaCanaleComunicazioneDTO>>;
    public patchTipoPraticaCanaleComunicazione(requestParameters: PatchTipoPraticaCanaleComunicazioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling patchTipoPraticaCanaleComunicazione.');
        }
        const idEvento = requestParameters?.idEvento;
        if (idEvento === null || idEvento === undefined) {
            throw new Error('Required parameter idEvento was null or undefined when calling patchTipoPraticaCanaleComunicazione.');
        }
        const idCanale = requestParameters?.idCanale;
        if (idCanale === null || idCanale === undefined) {
            throw new Error('Required parameter idCanale was null or undefined when calling patchTipoPraticaCanaleComunicazione.');
        }
        const tipoPraticaCanaleComunicazionePatchForm = requestParameters?.tipoPraticaCanaleComunicazionePatchForm;
        if (tipoPraticaCanaleComunicazionePatchForm === null || tipoPraticaCanaleComunicazionePatchForm === undefined) {
            throw new Error('Required parameter tipoPraticaCanaleComunicazionePatchForm was null or undefined when calling patchTipoPraticaCanaleComunicazione.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/eventi-comunicazione/${this.configuration.encodeParam({name: "idEvento", value: idEvento, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/canali/${this.configuration.encodeParam({name: "idCanale", value: idCanale, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TipoPraticaCanaleComunicazioneDTO>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tipoPraticaCanaleComunicazionePatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
